module.exports = __webpack_public_path__ + "static/img/tahoe.62c2332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/tahoe.jpg
// module id = I7Ud
// module chunks = 1